import CallLogs from "./callLogs";
import InteractionValue from "./interactionValue";

export default class Interaction {
    interaction_id: string;
    client_name: string;
    agency_name: string | undefined;
    case_id: string;
    client_reference_id: string;
    disposition_id: string;
    disposition_order: string;
    disposition_value: InteractionValue[];
    interaction_mode: string;
    interaction_type: string;
    image_url: string;
    ptp_date: string | undefined;
    followup_date: string | undefined;
    interaction_tag: string;
    visited_address: string | undefined;
    latitude: string;
    longitude: string;
    comment: string;
    created_date: string;
    created_by: string;
    updated_date: string;
    updated_by: string;
    translated_text: string | undefined;

    constructor(
        interaction_id: string,
        client_name: string,
        agency_name: string | undefined,
        case_id: string,
        client_reference_id: string,
        disposition_id: string,
        disposition_order: string,
        disposition_value: InteractionValue[],
        interaction_mode: string,
        interaction_type: string,
        image_url: string,
        ptp_date: string | undefined,
        followup_date: string | undefined,
        interaction_tag: string,
        visited_address: string | undefined,
        latitude: string,
        longitude: string,
        comment: string,
        created_date: string,
        created_by: string,
        updated_date: string,
        updated_by: string,
        translated_text: string | undefined,
    ) {
        this.interaction_id = interaction_id;
        this.client_name = client_name;
        this.agency_name = agency_name;
        this.case_id = case_id;
        this.client_reference_id = client_reference_id;
        this.disposition_id = disposition_id;
        this.disposition_order = disposition_order;
        this.disposition_value = disposition_value;
        this.interaction_mode = interaction_mode;
        this.interaction_type = interaction_type;
        this.image_url = image_url;
        this.ptp_date = ptp_date;
        this.followup_date = followup_date;
        this.interaction_tag = interaction_tag;
        this.visited_address = visited_address;
        this.latitude = latitude;
        this.longitude = longitude;
        this.comment = comment;
        this.created_date = created_date;
        this.created_by = created_by;
        this.updated_date = updated_date;
        this.updated_by = updated_by;
        this.translated_text = translated_text;
    }

    public static initialiseInteraction(responses: any): Interaction[] {
        let records: Interaction[] = [];
        for (const record of responses) {
            const interactionRecord = new Interaction(
                record.interaction_id,
                record.client_name,
                record.agency_name,
                record.case_id,
                record.client_reference_id,
                record.disposition_id,
                record.disposition_order,
                record.disposition_value,
                record.interaction_mode,
                record.interaction_type,
                record.image_url,
                record.ptp_date,
                record.followup_date,
                record.interaction_tag,
                record.visited_address,
                record.latitude,
                record.longitude,
                record.comment,
                record.created_date,
                record.created_by,
                record.updated_date,
                record.updated_by,
                record.translated_text,
            );
            records.push(interactionRecord);
        }
        return records;
    }
}
